module.exports = __webpack_public_path__ + "11526889ce18ad50a97c993eea79acaf.svg";


//////////////////
// WEBPACK FOOTER
// ../images/admin/campaign_ops_flow/campaign_config/icon-clipboard.svg
// module id = 335
// module chunks = 69